// Routes that render inside RedesignShell. App.js hides the legacy Navbar/Footer and the
// fixed-navbar top padding on these paths. Add a path here when its page is ported.
export const REDESIGN_PATHS = new Set([
  "/",
  "/home",
  "/product",
  "/pricing",
  "/our-story",
  "/findyourfit",
  "/enterprise",
  "/pilot",
  "/pilot/apply",
  "/register",
  "/contact",
  "/for-shops",
  "/discover",
  "/faq",
  "/partners/investors",
]);

const normalise = (pathname = "/") => {
  const trimmed = String(pathname || "/").replace(/\/+$/, "");
  return trimmed || "/";
};

export const isRedesignPath = (pathname) => REDESIGN_PATHS.has(normalise(pathname));
